export const BASE_URL = '/'
export const ORGANIZATION_LIST_URL = '/organizations'
export const CREATE_ORGANIZATION_URL = '/organizations/create'
export const UPDATE_ORGANIZATION_URL = '/organizations/:id'
export const USER_URL = '/users'
export const UPDATE_USER_URL = '/users/:id'
export const PRICING_TIER_URL = '/pricing-tiers'
export const UPDATE_PRICING_TIER_URL = '/pricing-tiers/:id'
export const CREATE_PRICING_TIER_URL = '/pricing-tiers/create'
